import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateChildFn,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import * as RelationApiActions from '@app/modules/relation/actions/relation-api.actions';
import { RelationService } from '@app/modules/relation/service/relation.service';
import { State } from '@app/reducers';
import { Store } from '@ngrx/store';
import { catchError, map, tap } from 'rxjs/operators';

export const canActivate: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const relationService = inject(RelationService);
    const router = inject(Router);
    const store = inject(Store<State>);

    return relationService.get(route.params['id']).pipe(
        map((relation) => RelationApiActions.GetSuccess(relation)),
        tap((action: any) => store.dispatch(action)),
        map((relation) => !!relation),
        catchError(() => {
            return router.navigate(['/not-found']);
        }),
    );
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    canActivate(route, state);
